import { useSelector } from "react-redux";
import { GATED_SHIFT_ROLES } from "../services/shiftService";

// Mirrors utils/middlewares/requireShift.js on the backend: clerk/handler/
// airportStaff/driver need an active shift before any write action; admin
// (and any other role) is never gated. Used to proactively disable buttons
// for actions the server would reject anyway with SHIFT_REQUIRED, rather
// than only surfacing that as a reactive toast after the click.
const useViewOnly = () => {
    const role = localStorage.getItem("role");
    const { checked, onShift } = useSelector((s) => s.activeShiftSlice);
    return GATED_SHIFT_ROLES.includes(role) && checked && !onShift;
};

export default useViewOnly;
